import Swiper, { Navigation, Pagination } from "swiper";
import { initIntersectionObserver } from "@plugins";

Swiper.use([Navigation, Pagination]);

const collectionsThumbs = document.querySelector(".collections-thumbs");

if (collectionsThumbs) {
    initIntersectionObserver(collectionsThumbs, initCollectionsThumbsSection);
}

function initCollectionsThumbsSection(section) {
    const categoriesContainer = section.querySelector(".js-collections-thumbs-categories");

    if (categoriesContainer) {
        new Swiper(categoriesContainer, {
            slidesPerView: "auto",
            autoScrollOffset: 0.5,
            watchOverflow: true,
            slideToClickedSlide: true,
            observer: true,
            navigation: {
                prevEl: ".js-collections-thumbs-categories-controls .swiper-button-prev",
                nextEl: ".js-collections-thumbs-categories-controls .swiper-button-next",
            },
        });

        const categories = categoriesContainer.querySelectorAll(".swiper-slide");

        categories.forEach((category) => {
            category.addEventListener("click", () => {
                categories.forEach((item) => item.classList.remove("active"));

                category.classList.add("active");
            });
        });
    }

    const sliderContainer = section.querySelector(".js-collections-thumbs-slider");

    if (sliderContainer) {
        new Swiper(sliderContainer, {
            slidesPerView: "auto",
            autoScrollOffset: 0.5,
            watchOverflow: true,
            slideToClickedSlide: true,
            observer: true,
            pagination: {
                el: ".js-collections-thumbs-slider-controls .swiper-pagination",
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
            },
            navigation: {
                prevEl: ".js-collections-thumbs-slider-controls .swiper-button-prev",
                nextEl: ".js-collections-thumbs-slider-controls .swiper-button-next",
            },
        });
    }
}
